import React, { Component } from 'react';
import Profile from '../../components/Header';
import About from '../../components/About';
import Projects from '../../components/ProjectsSlide';
import Contact from '../../components/Contact';
import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';
import ScrollUpButton from "react-scroll-up-button";
import {
  Bottom,
  Wrapper,
  ContactWrap,
  Form,
  Name,
  Email,
  Message,
  Button,
  ContainerContact,
} from './styles';

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.state = {
      status: ""
    };
  }

  render() {
    const { status } = this.state;
    return (
      <>
        <Navbar />
        <Profile />
        <About />
        <Projects />
        <Bottom>
          <Wrapper>
            <ContactWrap id="contact">
              <ContainerContact>
                <Contact />
                <Form
                  onSubmit={this.submitForm}
                  action="https://formspree.io/mjvakbpd"
                  method="POST"
                  >
                  <Name type="text" name="name" placeholder="Full name" />
                  <Email type="email" name="email" placeholder="Email" />
                  <Message type="textarea" name="message" placeholder="Message" />
                  {status === "SUCCESS" ? <p>Thanks!</p> : <Button>Send</Button>}
                  {status === "ERROR" && <p>Ooops! There was an error.</p>}
                </Form>
              </ContainerContact>
            </ContactWrap>
          </Wrapper>
        </Bottom>
        <ScrollUpButton
          StopPosition={0}
          ShowAtPosition={150}
          EasingType='easeOutCubic'
          AnimationDuration={500}
          ContainerClassName='ScrollUpButton__Container'
          TransitionClassName='ScrollUpButton__Toggled'
          style={{width: 75},{height: 50},{background: '#5e17eb'}}
          ToggledStyle={{}}
        />
        <Footer />
      </>
    );
  }

  submitForm(ev) {
    ev.preventDefault();
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        this.setState({ status: "SUCCESS" });
      } else {
        this.setState({ status: "ERROR" });
      }
    };
    xhr.send(data);
  }

}